import React, {FC} from 'react';
import classNames from 'classnames';

import AgentIcon from './svgs/agent.inline.svg';

import * as styles from './styles.module.scss';

type HeaderProps = {
	children: React.ReactNode
	open: boolean
}

export const Header: FC<HeaderProps> = ({children, open}) => {
	return (
		<div className={classNames({
			[styles.header]: true,
			[styles.open]: open,
			[styles.closed]: !open,
		})}>
			<div className={styles.icon}>
				<AgentIcon />
			</div>
			<div className={styles.title}>
				<div>What do your numbers mean? Ask</div>
			</div>
			<div className={styles.subtitle}>
				<div>Quick answers about your body composition</div>
			</div>
			<div className={styles.disclaimer}>
				<div>
					Conversations are recorded for quality.
					Consent by clicking <strong>Explain</strong>.
				</div>
			</div>
			<div className={styles.button}>
				{children}
			</div>
		</div>
	);
};
